import '../Styles/Header.css';
import logoBackGround from '../Images/logoBackGround.jpg';
export function MainHeader(){
    return(
        <div className='headerMainDiv'>
            <div className='headerLeftDiv'>
            </div>
            <div className='headerMidDiv'>
                <img src={logoBackGround} alt="title" />
            </div>
            <div className='headerRightDiv'></div>
        </div>
    )
}